(function() { window.GUID_9d3b4453_2acb_4942_bd09_50a147938ae3 = { getGuid: function() { return "9d3b4453-2acb-4942-bd09-50a147938ae3"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EventAndPersonaSubtopFormat;
        (function (EventAndPersonaSubtopFormat) {
            EventAndPersonaSubtopFormat[EventAndPersonaSubtopFormat["EventAndPersona"] = 0] = "EventAndPersona";
            EventAndPersonaSubtopFormat[EventAndPersonaSubtopFormat["EventOnly"] = 1] = "EventOnly";
            EventAndPersonaSubtopFormat[EventAndPersonaSubtopFormat["PersonaOnly"] = 2] = "PersonaOnly";
        })(EventAndPersonaSubtopFormat = Enumeration.EventAndPersonaSubtopFormat || (Enumeration.EventAndPersonaSubtopFormat = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EventAndPersonaSubtopFormat.pre.js.map
